import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useForm from "../../../hooks/useForm";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import Box from "../../shared/layouts/Box";
import Stack from "../../shared/layouts/Stack";
import PasswordCheckBox from "../../shared/PasswordCheckBox";
import Labeled from "../../shared/WithLabel";
import LoginContainer from "./LoginContainer";
import AlertMessageBanner from "../../shared/AlertMessageBanner";
import {useTranslation} from "react-i18next";
import {sendDataToReactNative} from "../../../utils/communicateWithRN";

const ResetPassword = () => {
  const [state, handleState] = useForm({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const [checks, setChecks] = useState({
    hasUppercase: false,
    hasNumber: false,
    hasSymbol: false,
    hasEightCharacters: false,
  });

  const [errors, setErrors] = useState({});
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const { token = "" } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    setIsPasswordValid(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*\W).{8,}$/g.test(state.password))
  }, [state.password])

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/password/reset", { ...state, token })
      .then(() => {
        window.location.replace("/dashboard");
      })
      .catch((err) => {
        setErrors(err.response.data.errors)
        sendDataToReactNative(JSON.stringify(err.response.data.errors))
      });
  };

  const handleOnChange = (e) => {
    const { value } = e.target;

    const checks = {
      hasUppercase: /[A-Z]/.test(value),
      hasNumber: /\d/.test(value),
      hasSymbol: /\W/.test(value),
      hasEightCharacters: /^.{8,}$/.test(value),
    };

    setChecks(checks);
    handleState(e);
  };

  return (
    <LoginContainer handleSubmit={handleSubmit}>
      <Box fontScale="2xl" fontWeight="bold">
        {t('Wachtwoord instellen')}
      </Box>
      {errors?.token && (
        <AlertMessageBanner severity="error">
          {errors.token[0]}
        </AlertMessageBanner>
      )}
      <Stack space="m">
        <Labeled label={t("E-mailadres")}>
          <Input
            name="email"
            value={state.email}
            onChange={handleState}
            errors={errors?.email}
          />
        </Labeled>
        <Labeled label={t("Wachtwoord")}>
          <Input
            name="password"
            type="password"
            value={state.password}
            onChange={handleOnChange}
            errors={errors?.password}
          />
        </Labeled>
      </Stack>
      <Box>
        <PasswordCheckBox value={checks.hasUppercase}>
          {'1 ' + t('Hoofdletter')}
        </PasswordCheckBox>
        <PasswordCheckBox value={checks.hasNumber}>
          {'1 ' + t('Cijfer')}
        </PasswordCheckBox>
        <PasswordCheckBox value={checks.hasSymbol}>
          {'1 ' + t('Symbool')}
        </PasswordCheckBox>
        <PasswordCheckBox value={checks.hasEightCharacters}>
          {'8 ' + t('Karakters')}
        </PasswordCheckBox>
      </Box>
      <Labeled label={t("Herhaal wachtwoord")}>
        <Input
          name="password_confirmation"
          type="password"
          value={state.password_confirmation}
          onChange={handleState}
          errors={errors?.password_confirmation}
        />
      </Labeled>
      <Button disabled={!isPasswordValid} variant="primary" width="100%" type="submit">
        {t('Stel wachtwoord in')}
      </Button>
    </LoginContainer>
  );
};
export default ResetPassword;
